import * as yup from 'yup';

const trialEmailSchema = () => (
  yup.object().shape({
    email: yup.string().email('Invalid email format').required('Email is Required'),
    password: yup.string()
      .min(6, 'Must be more than 5 characters')
      .required('Password is Required'),
  })
)

export default trialEmailSchema
